/* src/app/core/widgets/tabs/tab/tab.component.scss */
/*# sourceMappingURL=tab.component.css.map */
